import { useMemo } from 'react';
import { ThemeProvider, CssBaseline } from '@mui/material';
import { createFinanceTheme } from './theme';
import { useThemeMode } from './ThemeModeProvider.js';

export function MuiProvider({ children }: { children: React.ReactNode }) {
  const { resolvedMode } = useThemeMode();
  const theme = useMemo(() => createFinanceTheme({ mode: resolvedMode }), [resolvedMode]);

  return (
    <ThemeProvider theme={theme}>
      <CssBaseline enableColorScheme />
      {children}
    </ThemeProvider>
  );
}
